import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { ToastContainer,toast } from 'react-toastify';

import { baseURL} from '../../../../constants/applicationConstants.js';
import { allRegex, postalCodeRegex } from '../../../../shared/helper.js';
import { Loader } from '../../../common/loader/loader.jsx';
import CustomerAskTheExpertJsx from './adminModules.jsx'

export default class AskTheExpert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryData: null,
            formData: {
                name: '',
                newPermission: '',
            },
            checkedItems: [],
            permissions: [
                { name: "Read" },
                { name: "Create" },
                { name: "Delete" },
            ],
           
            showNewPermissionInput: false,
        };
    }
    

   
    componentDidMount = () => {
        this.setState({ isLoading: true })
        let token = JSON.parse(sessionStorage.getItem('token'));
        axios.get(`${baseURL}/modules`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            this.setState({ categoryData: res.data.data, isLoading: false })
        })
        const initialCheckedItems = this.permissions.map(permission => ({
            name: permission.name,
            slug: `${this.state.formData.name.replace(/\s+/g, '')}.${permission.name.toLowerCase()}`,
            hasPermission: true
        }));
    
        this.setState({ checkedItems: initialCheckedItems });
        
    }
    handlePermissionChange = (data, isChecked) => {
        const transformedData = {
            name: data.name,
            slug: `${this.state.formData.name.replace(/\s+/g, '')}.${data.name.toLowerCase()}`,
            hasPermission: isChecked
        };

        if (isChecked) {
            this.setState(prevState => ({
                checkedItems: [...prevState.checkedItems, transformedData]
            }));
        } else {
            this.setState(prevState => ({
                checkedItems: prevState.checkedItems.filter(item => item.name !== transformedData.name)
            }));
        }
    };

    handleNewPermissionSubmit = () => {
        const { newPermission } = this.state.formData;
        if (newPermission.trim()) {
            this.setState(prevState => {
                const newPermissionObj = {
                    name: newPermission,
                };
                return {
                    permissions: [...prevState.permissions, newPermissionObj],
                    showNewPermissionInput: false,
                };
            });
        } else {
            toast.error("Please enter a valid permission name.");
        }
    };

    toggleNewPermissionInput = () => {
        this.setState(prevState => ({
            showNewPermissionInput: !prevState.showNewPermissionInput
        }));
    };

    abhi = (data) => {
     
    
        // Initialize checkedItems with all permissions when the component mounts
        const initialCheckedItems = this.permissions.map(permission => ({
            name: permission.name,
            slug: `${data.replace(/\s+/g, '')}.${permission.name.toLowerCase()}`,
            hasPermission: true
        }));
    
        this.setState({ checkedItems: initialCheckedItems });
    
        
    }
    

    
   

    onSubmitButtonClick = () => {
        
        let token = sessionStorage.getItem("token") && JSON.parse(sessionStorage.getItem("token"))

        this.setState({ isLoading: true });
        const { name,} = this.state.formData;
        const payload = {
            moduleName: name,
            modulePermissions:this.state.checkedItems
        }

       

            axios.post(`${baseURL}/module`, payload, {
                headers: { 'x-access-token': token }
              }).then(res => {
                this.setState({ isLoading: false })
                toast.success("Category added succuessfully!")
                this.setState({ profileImagePreviewUrl: null })
    
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
            }).catch(err => {
                this.setState({ isLoading: false })
                toast.error(err?.response.data.erfrowsror.message);
            })
        
    }
    handleChange = (data, isChecked) => {
        const transformedData = {
            name: data.modulePermissionId,
            slug: `${this.state.formData.name.replace(/\s+/g, '')}.${data.modulePermissionId.toLowerCase()}`,
            hasPermission: isChecked
        };
    
        if (isChecked) {
            // If checked, add transformed data to checkedItems
            this.setState(prevState => ({
                checkedItems: [...prevState.checkedItems, transformedData]
            }));
        } else {
            // If unchecked, remove transformed data from checkedItems
            this.setState(prevState => ({
                checkedItems: prevState.checkedItems.filter(item => item.name !== transformedData.name)
            }));
        }
    
    };
    
    
    onInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.abhi(value)
        if (name === 'category') {
            this.onCatgoryClick(value)
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        'subCategory': '',
                    }
                }
            )

        }


        if (value) {
            if (!this.inputRegexValidation(name, value)) {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "regx",
                        },
                    },
                    
                );
            } else {
                this.setState(
                    {
                        formData: {
                            ...this.state.formData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "",
                        },
                    },
                   
                );
            }
        } else {
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        [name]: value,
                    },
                    formError: {
                        ...this.state.formError,
                        [name]: "",
                    },
                },
                
            );
        }
    }
    inputRegexValidation = (name, value) => {
        if (name === 'name')
            return allRegex.test(value);
        if (name === 'postalCode')
            return postalCodeRegex.test(value);

        return true;
    };
    onTouchHandler = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        if (name === 'category') {
            this.onCatgoryClick(value)
            this.setState(
                {
                    formData: {
                        ...this.state.formData,
                        'subCategory': '',
                    }
                }
            )

        }

        if (value === "") {
            this.setState({
                formError: {
                    ...this.state.formError,
                    [name]: "req",
                },
            });
        } else {
            if (!this.inputRegexValidation(name, value)) {
                this.setState({
                    formError: {
                        ...this.state.formError,
                        [name]: "regx",
                    },
                });
            }
        }
    };
     permissions = [
        {
    
          "name": "Read"
        },
        {
    
          "name": "Create"
        },
        {
    
          "name": "Delete"
        }
      ]
    

    render() {
        return (
            <div>
                <CustomerAskTheExpertJsx
                   categoryData={this.state.categoryData}
                   formData={this.state.formData}
                   onSubmitButtonClick={this.onSubmitButtonClick}
                   permissions={this.state.permissions}
                   checkedItems={this.state.checkedItems}
                   handlePermissionChange={this.handlePermissionChange}
                   toggleNewPermissionInput={this.toggleNewPermissionInput}
                   showNewPermissionInput={this.state.showNewPermissionInput}
                   newPermission={this.state.newPermission}
                   handleNewPermissionSubmit={this.handleNewPermissionSubmit}
                   onInputChange={this.onInputChange}
                   handleChange={this.handleChange}
                />
                {this.state.isLoading && <Loader />}
                <ToastContainer />            </div>
        )
    }
}
